var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column"},[_c('div',{staticClass:"first-line"},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"right"},[_vm._t("right")],2)],2),_vm._v(" "),_c('div',[_vm._t("second-line")],2),_vm._v(" "),_vm._t("extend")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }